import {
  PlayerImage,
  PlayerName,
  PlayerProfile,
  PlayerSecondaryHeader,
  PlayerSubheader
} from '@library/components/player';
import { Input } from '@library/components/inputs';

interface ProjectionSearchProps {
  isProjectionDataLoading: boolean;
  isProjectionValid: boolean;
  onValueChange: (value: string | number | undefined) => void;
  playerImgUrl: string | undefined;
  playerName?: string;
  projectedScore: string | undefined;
  projectionId: string | number | undefined;
  teamDetails: string | undefined;
}

export const ProjectionSearch = ({
  isProjectionDataLoading,
  isProjectionValid,
  onValueChange,
  playerImgUrl,
  playerName = '',
  projectedScore,
  projectionId,
  teamDetails
}: ProjectionSearchProps) => {
  return (
    <div>
      <p className="text-soClean-180 mb-1 text-sm">
        Projection ID
        <span className="text-stankonia-100">*</span>
      </p>
      <Input value={projectionId ?? ''} onValueChange={onValueChange} />
      <PlayerProfile
        className="border-soFresh-140 mt-4 flex h-16 items-center rounded-lg border"
        name={playerName}
        subheader={teamDetails}
        imageUrl={playerImgUrl}
        secondaryHeader={projectedScore}
      >
        {isProjectionValid ? (
          <>
            <div className="border-soFresh-140 flex size-full items-center border-r px-4">
              <PlayerImage className="bg-soFresh-120 mr-4 size-12 rounded-lg" />
              <div className="flex flex-col">
                <PlayerName className="text-soClean-100 text-xs font-medium" />
                <PlayerSubheader className="text-soClean-160 text-xs font-medium" />
              </div>
            </div>
            <div className="flex w-full flex-col px-4">
              <PlayerSecondaryHeader className="text-soClean-100 text-base font-medium" />
              <p className="text-soClean-100 text-xs">Points</p>
            </div>
          </>
        ) : (
          <p className="text-soClean-190 px-4 text-sm">
            {isProjectionDataLoading
              ? 'Loading...'
              : 'Enter a valid projection ID to view corresponding attributes'}
          </p>
        )}
      </PlayerProfile>
    </div>
  );
};
